import { useStoreByMessageId } from './useStoreByMessageId';

export const useChatMessageHasThinkDeeperTriggered = ({
	messageId,
}: {
	messageId: string;
}): boolean => {
	const [state] = useStoreByMessageId(messageId);
	return state?.hasThinkDeeperTriggered ?? false;
};
